import { useState, useEffect } from 'react';
import { useUserContext } from '../contexts/UserContext';
import toast from 'react-hot-toast';
import LoadingSpinner from '../components/ui/LoadingSpinner';

export default function MembershipManagementPage() {
  const { hasPermission } = useUserContext();
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState<'pauses' | 'guest-passes' | 'transfers'>('pauses');

  const canManageMembers = hasPermission('manage_members');

  useEffect(() => {
    if (canManageMembers) {
      fetchData();
    }
  }, [canManageMembers, activeTab]);

  const fetchData = async () => {
    try {
      setLoading(true);
      // TODO: Implement data fetching for pauses, guest passes, and transfers
      // This will be implemented when the admin endpoints are ready
    } catch (error) {
      console.error('Error fetching data:', error);
      toast.error('Failed to load data');
    } finally {
      setLoading(false);
    }
  };

  if (!canManageMembers) {
    return (
      <div className="bg-white rounded-2xl shadow-lg p-12 text-center">
        <p className="text-gray-500">You don't have permission to access this page.</p>
      </div>
    );
  }

  if (loading) {
    return <LoadingSpinner />;
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-gray-900">Membership Management</h1>
        <p className="text-gray-600 mt-1">Manage pauses, guest passes, and transfers</p>
      </div>

      {/* Tabs */}
      <div className="bg-white rounded-2xl shadow-lg border border-gray-100">
        <div className="border-b border-gray-200">
          <nav className="flex space-x-8 px-6" aria-label="Tabs">
            <button
              onClick={() => setActiveTab('pauses')}
              className={`py-4 px-1 border-b-2 font-medium text-sm ${
                activeTab === 'pauses'
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              Pause Requests
            </button>
            <button
              onClick={() => setActiveTab('guest-passes')}
              className={`py-4 px-1 border-b-2 font-medium text-sm ${
                activeTab === 'guest-passes'
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              Guest Passes
            </button>
            <button
              onClick={() => setActiveTab('transfers')}
              className={`py-4 px-1 border-b-2 font-medium text-sm ${
                activeTab === 'transfers'
                  ? 'border-blue-500 text-blue-600'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
            >
              Plan Transfers
            </button>
          </nav>
        </div>

        <div className="p-6">
          {activeTab === 'pauses' && (
            <div className="space-y-4">
              <p className="text-gray-500">Pause request management coming soon...</p>
            </div>
          )}
          {activeTab === 'guest-passes' && (
            <div className="space-y-4">
              <p className="text-gray-500">Guest pass management coming soon...</p>
            </div>
          )}
          {activeTab === 'transfers' && (
            <div className="space-y-4">
              <p className="text-gray-500">Plan transfer management coming soon...</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

